import React, { useEffect } from 'react';
import { StepWrapper } from 'containers/Demarrage/components/StepWrapper';
import 'twin.macro';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import AnimationPlayer from 'components/AnimationPlayer/Loadable';

export function Preparation() {
  const { email } = useUser();
  const { search } = useLocation();
  const { t } = useTranslation(['onboarding']);
  const navigate = useNavigate();
  const goFast = email.endsWith('@teetsh.com');

  useEffect(() => {
    const timer = setTimeout(
      () => {
        navigate(`/demarrage/final${search}`);
      },
      goFast ? 10 : 3500,
    );

    return () => {
      clearTimeout(timer);
    };
  }, [search, navigate, goFast]);

  return (
    <StepWrapper
      title={t('onboarding:preparation.title')}
      currentStep="preparation"
      centerTitle
      presentationSlice
      nextDisabled
      hideFooter
      header={
        <div tw="min-h-80 flex items-center justify-center">
          <AnimationPlayer src="/configuration.json" loop={false} />
        </div>
      }
    />
  );
}
